import * as actionTypes from '../../actionTypes'
import { updateObject } from '../../../utility/Redux'
const initialState = {
    data: [],
    count: 1,
    active: 0,
    players: [],
    error: false
}

const handleActive = (active, count) => {
    if(active === (count-1)){
        return 0
    }else{
        return active+1
    }
}

const handleScore = (players, id, summary) => {
    let players_ = [...players]
    players_[id].score += (summary.points + summary.bonuses)
    players_[id].answerStatus.push(summary)
    return players_
}

const resetScore = (players) => {
    let players_ = [...players]
    players_.map(player => player.score = 0)
    players_.map(player => player.answerStatus = [])
    return players_
}

const handleHistory = (players) => {
    let players_ = [...players]
    players_.map(player => player.answerStatus = [])
    return players_
}

const reducer =(state = initialState, action) => {
    switch(action.type){
        case actionTypes.PLAYER_SET_PLAYERS:
            return updateObject(state, {count: action.count, players: action.players})
        case actionTypes.PLAYER_SET_NEXT_PALYER:
            return updateObject(state, {active: handleActive(state.active, state.count)})
        case actionTypes.PLAYER_RESET_PLAYERS:
            return updateObject(state, {active: 0})
        case actionTypes.PLAYER_ADD_SCORE:
            return updateObject(state, {players: handleScore(state.players, action.id, action.summary)})
        case actionTypes.PLAYER_RESET_SCORE:
            return updateObject(state, {players: resetScore(state.players), active:0})
        case actionTypes.PLAYER_RESET_SCORE_HISTORY:
            return updateObject(state, {players: handleHistory(state.players), active:0})
        default:
            return state
    }
}

export default reducer